<template>
  <label
    :class="classes"
    :alt="`Selecionado: ${selected.label}`"
    :disabled="disabled || loading"

    tabindex="0"

    @blur="blur"
    @focus="focus"

    @click.stop.capture="toggle"
    @keydown.enter.exact="toggle"
    @keydown.space.exact.prevent="toggle"
  >
    <input
      :name="name"
      :checked="value"
      class="cordel-toggler-input"
      type="checkbox"
      tabindex="-1"
    >

    <span class="cordel-toggler-outside">
      <span class="cordel-toggler-inside" />
    </span>
  </label>
</template>

<script>
  const DEFAULT_OPTIONS = [{
    label: 'Sim',
    value: true,
  }, {
    label: 'Não',
    value: false,
  }];

  export default {
    name: 'CordelToggler',
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      classes() {
        const classes = ['cordel-toggler'];

        if (this.value) {
          classes.push('state--active');
        }

        if (this.loading || this.disabled) {
          classes.push('state--disabled');
        }

        return classes;
      },
      selected() {
        return DEFAULT_OPTIONS.find(option => option.value === this.value);
      },
    },
    methods: {
      toggle(e) {
        if (this.disabled || this.loading) {
          return;
        }

        this.$emit('input', !this.value);
        this.$emit('change', e);
      },
      blur(e) {
        this.$emit('blur', e);
      },
      focus(e) {
        this.$emit('focus', e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-toggler {
    border-radius: var(--cordel-border-radius-pill);
    cursor: pointer;
    display: block;
    outline: none;
    margin: calc(var(--cordel-spacing-xmini) * -1);
    padding: var(--cordel-spacing-xmini);

    &:focus {
      box-shadow: 0 0 0
                  var(--cordel-border-width-thin)
                  var(--cordel-color-highlight-primary);
    }
  }

  .state--disabled {
    cursor: not-allowed;
  }

  .cordel-toggler-input {
    display: none;
  }

  .cordel-toggler-outside {
    background-color: transparent;
    border: var(--cordel-border-width-thin) solid var(--cordel-color-neutral-dark);
    border-radius: inherit;
    display: block;
    padding: var(--cordel-spacing-xmini);
    transition: background-color .1s, border-color .1s;

    .state--active & {
      background-color: var(--cordel-color-alert-information);
      border-color: var(--cordel-color-alert-information);
    }

    .state--disabled & {
      background-color: transparent;
      border-color: var(--cordel-color-neutral-dark);
    }
  }

  .cordel-toggler-inside {
    background-color: var(--cordel-color-neutral-dark);
    border: var(--cordel-border-width-thin) solid var(--cordel-color-neutral-dark);
    border-radius: inherit;
    display: block;
    height: var(--cordel-font-size-xs);
    margin: 0 calc(var(--cordel-font-size-xs) + var(--cordel-spacing-xmini)) 0 0;
    width: var(--cordel-font-size-xs);
    transition: background-color .1s, border-color .1s, margin .1s;

    .state--active & {
      background-color: var(--cordel-color-constant-light);
      border-color: var(--cordel-color-constant-light);
      margin: 0 0 0 calc(var(--cordel-font-size-xs) + var(--cordel-spacing-xmini));
    }

    .state--disabled & {
      background-color: transparent;
      border-color: var(--cordel-color-neutral-dark);
    }
  }
</style>
